'use srict'

import React,{Component} from 'react';

import sortByDate from '../../app/utils/sortByDate.js';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

export default class LastIssueReports extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report;
    var reports=this.props.issues!==undefined
     ? [].concat.apply(
          [],
          this.props.issues.map(issue=>issue.reports)
        )
          .filter(report=>report!==null && report!==undefined)
          .sort(sortByDate)
          .reverse()
          .slice(0,8)
      : [];
    return reports.length>0 ? (
      <div>
        <div style={{fontSize:"110%", paddingBottom: 5}}>
          <b>{labels.lastIssueReports}</b>
          </div>
        {reports.map(report=>(
          <div style={{paddingBottom: 3 }} key={report.id}>
            [{report.date!==undefined ? new Date(Date.parse(report.date)).toISOString().slice(0,10): ""}]
            <span> </span>
            <a style={{fontStyle: report.project!==undefined ? "italic" : undefined}} href={(report.project!==undefined ? "/projects/"+report.project.id+"/" : "")+"change/issues/"+report.issue.id+"/reports/"+report.id}>{report.issue.no}. {report.issue.title}</a>
            {report.exception ? (
              <img style={{paddingLeft:5, height: "10pt"}} src="/images/Flag_DarkGrey_22x16.gif"/>
            ) : null}
          </div>
        ))}
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./views/change/LastIssueReports.jsx